import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
  isDevMode,
  importProvidersFrom,
  LOCALE_ID,
} from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
/* Dati del locale italiano di moment. Serve un import esplicito: nel bundle per
   il browser moment porta solo l'inglese, quindi senza questa riga il
   MomentDateAdapter dei datepicker (new-invoice, invoice-detail, ...) chiede il
   locale 'it-IT', non lo trova e ripiega in silenzio sull'inglese - mesi e
   giorni del mini-calendario restano cosi' in inglese anche con
   MAT_DATE_LOCALE impostato. L'import registra il locale e imposta anche il
   default globale di moment, che vale per i format usati direttamente nei
   componenti. */
import 'moment/locale/it';
import { provideRouter } from '@angular/router';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { FIREBASE_OPTIONS } from '@angular/fire/compat';
import { routes } from './app.routes';
// import {
//   provideClientHydration,
//   withEventReplay,
// } from '@angular/platform-browser';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from '@environments/environment';
import { provideHttpClient } from '@angular/common/http';
// Plotly imports
// import * as PlotlyJS from 'plotly.js-dist-min';
// import { PlotlyModule } from 'angular-plotly.js';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { Chart } from 'chart.js';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerIntl } from '@angular/material/datepicker';
import { CustomDatepickerIntl } from '@app/services/custom-datepicker-intl.service';

// PlotlyModule.plotlyjs = PlotlyJS;

registerLocaleData(localeIt);

// I grafici (canvas) non ereditano il font dal CSS: va impostato su Chart.js.
Chart.defaults.font.family = '"Outfit", system-ui, sans-serif';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    { provide: LOCALE_ID, useValue: 'it-IT' },
    /* Locale ed etichette dei datepicker, a livello di root: cosi' ogni
       calendario dell'app e' in italiano senza doverlo ripetere componente per
       componente. MAT_DATE_LOCALE ripiegherebbe di suo su LOCALE_ID, ma lo si
       dichiara comunque per non far dipendere il formato delle date da una
       impostazione che riguarda tutta l'app. */
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
    { provide: MatDatepickerIntl, useClass: CustomDatepickerIntl },
    provideRouter(routes),
    // Provide ng2-charts with default chart types (Bar, Line, etc.)
    provideCharts(withDefaultRegisterables()),
    // importProvidersFrom(PlotlyModule), // Import PlotlyModule
    // provideClientHydration(withEventReplay()),
    // provideServiceWorker('ngsw-worker.js', {
    //   enabled: !isDevMode(),
    //   registrationStrategy: 'registerWhenStable:30000',
    // }),
    { provide: FIREBASE_OPTIONS, useValue: environment.firebase },
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideHttpClient(),
    provideCharts(withDefaultRegisterables()),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    provideMessaging(() => getMessaging()),
    provideAuth(() => getAuth()),
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      },
    },
  ],
};
